{
  "common": {
    "login": "Sign in",
    "submit": "Submit",
    "error": "Error"
  },
  "vault": {
    "title": "Secured Document Vault",
    "description": "Store your important documents in a secure vault",
    "success": "Success!",
    "successMessage": "Your files have been uploaded successfully"
  },
  "login": {
    "email": "Email",
    "code": "Code",
    "continue": "Login to continue",
    "input": "Please input your email to login.",
    "receive": "A code will be sent to you by email to confirm your identity.",
    "inputCode": "Input code to continue",
    "receiveCode": "Please input the code you received by email.",
    "tooManyRequests": "Too many requests",
    "pleaseTryAgainLater": "Please wait before requesting a new code.",
    "errorOccurred": "An error occurred while sending the code."
  },
  "user": {
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "message": "Message"
  },
  "files": {
    "name": "Name",
    "size": "Size",
    "date": "Date",
    "actions": "Actions"
  },
  "upload": {
    "drag": "Drag and drop your files here or click to select files",
    "attach": "Attach as many files as you want, up to {{maxSize}}MB each"
  },
  "footer": {
    "unicorne": "© 2024 Unicorne",
    "politics": "Privacy Policy",
    "conditions": "Terms of Use"
  }
}
